import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ButtonCustom from '../../../../../Components/ButtonCustom'
import { Box } from '../../../../../Components/CustomUi/box'
import { Inline } from '../../../../../Components/CustomUi/inline'
import Input from '../../../../../Components/CustomUi/input'
import { ItensPerUserLogged } from '../../../../../services/login/permissaoUsuarioLoado'
import { removerAcentos } from '../../../../../utils'
import {
  faDownload,
  faEdit,
  faMapLocationDot,
  faPen,
  faPlus,
  faUpload,
} from '@fortawesome/free-solid-svg-icons'
import { HeaderTable } from '../../../../../Components/CustomUi/table/headerTable'
import { BodyTable } from '../../../../../Components/CustomUi/table/bodyTable'
import { Render } from '../../../../../Components/CustomUi/render'
import { RowTable } from '../../../../../Components/CustomUi/table/rowTable'
import { RowItem } from '../../../../../Components/CustomUi/table/rowItem'
import { DeleteButton } from '../../../../../Components/CustomUi/deleteButton'
import { Empty, Tooltip, Upload } from 'antd'
import Carregando from '../../../../../Components/CustomUi/loading'
import { Select } from '../../../../../Components/CustomUi/Select'
import { useRef, useState } from 'react'
import { TalhaoItens } from '../../../../../services/Talhao'
import { PropriedadeItens } from '../../../../../services/Propriedades'
import Svg from '../../../../../Components/talhasvg'
import Icon from '@ant-design/icons'
import { UploadChangeParam } from 'antd/lib/upload'
import GeneratePdfButton from '../../../../../Components/relatorio-component'
import { destroyAlert, loadingAlert, warningAlert } from '../../../../../utils/alert'
import { centerMap, fileTypeText, parseXml } from '../../../../../services/Afins'
import { kml } from '@tmcw/togeojson'
import { TabelaTalhãoPropriedade } from './styles'
import { TypesMapa } from '../../novo-index'
import secureLocalStorage from 'react-secure-storage'

interface TypeDataTalhao {
  alert?: boolean
  talhao: string
  ativo: boolean
  coord:
  | {
    lat: number
    lng: number
  }[]
  | google.maps.LatLng
}
interface Props {
  loading: boolean
  setPagination: React.Dispatch<React.SetStateAction<number>>
  page: number
  setPage: React.Dispatch<React.SetStateAction<number>>
  total: number
  update: number
  listar_talhoes: TalhaoItens[]
  listar_propriedades: PropriedadeItens[]
  abrir: Function
  desenhar: Function
  permissao: ItensPerUserLogged
  editarCadastro: Function
  deletar: Function
  download: Function
  confirmar_exclusao: boolean
  setConfirmar_exclusao: React.Dispatch<React.SetStateAction<boolean>>
  id_item_atual: number
  setId_item_atual: React.Dispatch<React.SetStateAction<number>>
  nome_item_atual: string
  setNome_item_atual: React.Dispatch<React.SetStateAction<string>>
  fake_loading: boolean
  setFake_loading: React.Dispatch<React.SetStateAction<boolean>>
  buscarTabela: string
  setBuscarTabela: React.Dispatch<React.SetStateAction<string>>
  propriedade: string
  setPropriedade: React.Dispatch<React.SetStateAction<string>>
  selecionar_propriedade: React.Dispatch<React.SetStateAction<number>>
  setDataPolygon: React.Dispatch<React.SetStateAction<TypeDataTalhao[]>>
  setPropsMapa: React.Dispatch<React.SetStateAction<TypesMapa>>
  setNameTalhao: React.Dispatch<React.SetStateAction<string>>
  setPolygonTalhao: React.Dispatch<React.SetStateAction<any[]>>
  setVisibleImportTalhao: React.Dispatch<React.SetStateAction<boolean>>
  dadosEstatisticas: any[]
  dadosResultado: any[]
  dataTalhao: any[]
  nomePropriedade: string
}

export const TabelaTalhoesPropriedade: React.FC<Props> = ({
  loading,
  page,
  setPage,
  setPagination,
  total,
  update,
  listar_talhoes,
  listar_propriedades,
  permissao,
  abrir,
  desenhar,
  editarCadastro,
  deletar,
  download,
  confirmar_exclusao,
  setConfirmar_exclusao,
  id_item_atual,
  setId_item_atual,
  nome_item_atual,
  setNome_item_atual,
  fake_loading,
  setFake_loading,
  buscarTabela,
  setBuscarTabela,
  propriedade,
  setPropriedade,
  selecionar_propriedade,
  setDataPolygon,
  setPropsMapa,
  setNameTalhao,
  setPolygonTalhao,
  setVisibleImportTalhao,
  dadosEstatisticas,
  dadosResultado,
  dataTalhao,
  nomePropriedade,
}) => {
  const uploadFile = useRef(null)
  const [openPropriedade, setOpenPropriedade] = useState(false)

  function buscarPatrimonios(buscar_nome: string) {
    const palavraSemAcentos = removerAcentos(buscar_nome)
    return function (item) {
      const nomeSemAcentos = removerAcentos(String(item?.nome))
      return nomeSemAcentos.toLowerCase().includes(palavraSemAcentos.toLowerCase()) || !buscar_nome
    }
  }

  const onChangeUpload = async (info: UploadChangeParam) => {
    loadingAlert({ msg: 'Carregando talhões...', id: 'load_talhao' })

    if (info.file.status === 'done') {
      const domKml = parseXml(await fileTypeText(info.file.originFileObj))
      const dataGeoJson = kml(domKml)

      const propridade = []
      const talhoes = []

      const dados = dataGeoJson.features
      const filtrado = dados.filter((data) => data.geometry.type === 'Polygon')

      if (filtrado.length > 0) {
        for (const item of filtrado) {
          const fragment = item
          const talhaoPoly = []

          const coordinates = fragment.geometry.coordinates[0]

          for (const item_coordenada of coordinates) {
            const coord = item_coordenada

            talhaoPoly.push({ lat: coord[1], lng: coord[0] })
          }

          setNameTalhao(
            fragment.properties.name ? fragment.properties.name : fragment.properties.NOME
          )
          propridade.push({
            talhao: fragment.properties.name ? fragment.properties.name : fragment.properties.NOME,
            coord: talhaoPoly,
            ativo: true,
          })
          talhoes.push(talhaoPoly)
        }
      } else {
        warningAlert('Arquivo Inválido!', 5000, 'load_talhao')
      }
      setPolygonTalhao(talhoes)
      setDataPolygon(propridade)
      destroyAlert('load_talhao')
      setVisibleImportTalhao(true)
      const centerPoly = centerMap(talhoes)

      setPropsMapa({
        center: centerPoly,
        zoom: 11,
      })
    }
  }

  const dummyRequest = (options) => {
    const { onSuccess } = options
    setTimeout(() => {
      onSuccess('done')
    }, 500)
  }

  return (
    <TabelaTalhãoPropriedade>
      <Box style={{ marginTop: 7 }} gap={10} padding={0} borderless>
        <Inline>
          <Tooltip title='Cria novo talhão dentro da propriedade (importando ou desenhando contorno).'>
            <div>
              <ButtonCustom
                icon={<FontAwesomeIcon icon={faPlus} />}
                onClick={() => abrir()}
                disabled={update <= 0}
              // hidden={permisao_inclusao}
              >
                Novo
              </ButtonCustom>
            </div>
          </Tooltip>

          <Tooltip title='Importa kml do talhão para a propriedade'>
            <Upload
              accept='.kml'
              ref={uploadFile}
              onChange={onChangeUpload}
              showUploadList={false}
              maxCount={1}
              multiple={false}
              customRequest={dummyRequest}
            >
              <ButtonCustom
                type='secondary'
                icon={<FontAwesomeIcon icon={faUpload} />}
                onClick={undefined}
                disabled={update <= 0}
              >
                Importar
              </ButtonCustom>
            </Upload>
          </Tooltip>

          <Tooltip title='Desenhar talhão com mapa de satélite ao fundo dentro da propriedade.'>
            <div>
              <ButtonCustom
                icon={<FontAwesomeIcon icon={faPen} />}
                onClick={() => {
                  desenhar()
                }}
                disabled={update <= 0}
                type='secondary'
              >
                Desenhar
              </ButtonCustom>
            </div>
          </Tooltip>

          <Tooltip title='Imprimir lista de talhões da propriedade'>
            <div>
              <Render condition={secureLocalStorage.getItem('tipo-acesso') === 'conta'}>
                <GeneratePdfButton
                  dados={dadosEstatisticas}
                  title={'Relatório de talhões da safra'}
                  totais={dadosResultado}
                  disable={dataTalhao.length <= 0}
                  titleSecundario={nomePropriedade}
                />
              </Render>
            </div>
          </Tooltip>
        </Inline>
        <Inline>
          <Select
            placeholder='Selecione a propriedade'
            value={propriedade}
            onChange={setPropriedade}
            onChangeID={selecionar_propriedade}
            open={openPropriedade}
            trigger={setOpenPropriedade}
            descricaoItem='nome'
            idItem='cod'
            items={listar_propriedades}
            width={'30%'}
            icon={faMapLocationDot}
            extraItem={'cod'}
            allowClear={false}
          />
          <Input
            placeholder='Buscar talhão de propriedade'
            value={buscarTabela}
            onChange={setBuscarTabela}
            width={'70%'}
          />
        </Inline>
        <HeaderTable
          style={{ marginTop: -20 }}
          itens={[
            { valor: 'Talhão', width: '80.5px' },
            { valor: 'Nome', width: 'calc(100% - 551.5px)' },
            { valor: 'Área(ha)', width: '105.5px' },
            { valor: 'Ações', width: '360px' },
          ]}
        />

        <BodyTable
          paginate={total}
          onChangeItensPage={setPagination}
          onChangePage={setPage}
          current_page={page}
          setCurrent_page={setPage}
          style={{
            height: 'calc(100vh - 350px)',
            position: 'relative',
            overflowX: 'hidden',
            overflowY: 'scroll',
            marginTop: -10,
          }}
        >
          <Render condition={!loading}>
            {(listar_talhoes ?? [])
              .filter(buscarPatrimonios(buscarTabela))
              .map(({ cod, nome, arquivo, kml, area }) => {

                return (
                  <RowTable key={cod} onDoubleClick={() => { }}>
                    <RowItem width={'80px'}>
                      <Icon
                        // @ts-ignore
                        component={() => <Svg coordinates={kml?.coordenadas} fill='#70ce9f' />}
                      />
                    </RowItem>
                    <RowItem fontSize={13} width={'calc(100% - 545px)'}>
                      {nome}
                    </RowItem>
                    <RowItem fontSize={13} width={'105px'}>
                      {area}
                    </RowItem>

                    <RowItem width={'360px'} gap={10}>
                      <ButtonCustom
                        icon={<FontAwesomeIcon icon={faDownload} />}
                        onClick={() => download(arquivo, nome, cod)}
                        disabled={permissao?.alteracao === 0 && permissao?.acesso === 0}
                        type='tertiary'
                        title='Baixar kml'
                      >Baixar kml</ButtonCustom>
                      <DeleteButton
                        open={confirmar_exclusao && id_item_atual === cod}
                        trigger={setConfirmar_exclusao}
                        onTrigger={() => {
                          setId_item_atual(cod)
                          setNome_item_atual(nome)
                        }}
                        loading={fake_loading}
                        message={`o item ${nome} será excluido!`}
                        deleteds={[nome]}
                        onDelete={() => {
                          deletar(cod)
                        }}
                        disabled={fake_loading}
                        textButtonTrigger='Excluir'
                        typeButtonTrigger='primary'
                        disabledTrigger={permissao?.exclusao === 0}
                      />
                      <ButtonCustom
                        icon={<FontAwesomeIcon icon={faEdit} />}
                        onClick={() => editarCadastro(cod)}
                        disabled={permissao?.alteracao === 0 && permissao?.acesso === 0}
                      >
                        Editar
                      </ButtonCustom>
                    </RowItem>
                  </RowTable>
                )
              })}
          </Render>

          <Render condition={listar_talhoes.length === 0 && !loading}>
            {buscarTabela === '' ? (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={<> Nenhum registro disponível!</>}
              />
            ) : (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={
                  <>
                    {' '}
                    <b>'{buscarTabela}'</b> não encontrado!
                  </>
                }
              />
            )}
          </Render>

          <Render condition={loading}>
            <Carregando
              animation
              legenda='Carregando talhões da propriedade...'
              justifyContent='center'
              height={200}
              size='default'
            />
          </Render>
        </BodyTable>
      </Box>
    </TabelaTalhãoPropriedade>
  )
}